import { render, staticRenderFns } from "./UnfreezePackage.vue?vue&type=template&id=982aceb6&scoped=true"
import script from "./UnfreezePackage.vue?vue&type=script&lang=js"
export * from "./UnfreezePackage.vue?vue&type=script&lang=js"
import style0 from "./UnfreezePackage.vue?vue&type=style&index=0&id=982aceb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "982aceb6",
  null
  
)

export default component.exports